export default __webpack_public_path__ + "static/media/macbook-air-13-inch-m1-8gb-256gb.7dad75f3.jpg";